module.exports = __webpack_public_path__ + "img/greens_bg.9c1d4c05.png";